import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useModal } from 'mui-modal-provider';
import { makeStyles } from 'tss-react/mui';
import {
    useCreateContactOwner,
    useDeleteContactOwnerFromFollowers,
} from '../../../sic-lib/api/hooks/useContact';
import { UserInfoWithOwnershipFlag } from '../../../sic-lib/types/ContactOwner';
import { UserAvatar } from '../../Settings/Users/UserAvatar';
import ButtonLoading from '../../Shared/ButtonLoading';
import DialogConfirmAction from '../../Shared/DialogConfirmAction/DialogConfirmAction';

interface Props {
    data: UserInfoWithOwnershipFlag;
    contactId: number;
}

export default function FollowerDialogSelectItem({ data, contactId }: Props) {
    const { showModal } = useModal();
    const { classes } = useStyles();

    const { mutate: createContactOwner, isLoading: isLoadingCreate } =
        useCreateContactOwner(contactId);

    const { mutate: removeFollower, isLoading: isLoadingDelete } =
        useDeleteContactOwnerFromFollowers(contactId);

    const handleAddFollower = () => {
        createContactOwner({
            userName: data.userName,
            isPrimary: false,
            contactId: contactId,
        });
    };

    const handleClick = () => {
        if (data.flag === 'follower') {
            const modal = showModal(DialogConfirmAction, {
                title: 'Remove Follower',
                description: `Are you sure you want to remove ${data.userName}?`,
                onConfirm: () =>
                    removeFollower({
                        userName: data.userName,
                    }),
                onCancel: () => {
                    modal.hide();
                },
            });
        } else if (data.flag === 'unassigned') {
            handleAddFollower();
        }
    };

    return (
        <ListItem disableGutters key={data.userName}>
            <ListItemButton onClick={handleClick}>
                <ListItemAvatar>
                    <UserAvatar user={data} scale={2.5} />
                </ListItemAvatar>
                <ListItemText
                    primary={data.userName}
                    secondary={data.firstName + ' ' + data.lastName}
                />
                <ButtonLoading
                    isLoading={isLoadingCreate || isLoadingDelete}
                    startIcon={data.flag === 'follower' ? <RemoveIcon /> : <AddIcon />}
                >
                    {data.flag === 'follower' ? 'Remove' : 'Add'}
                </ButtonLoading>
            </ListItemButton>
        </ListItem>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    menuBorder: {
        borderTop: `1px solid ${theme.palette.divider}`,
    },
}));
